import { Component, OnDestroy, OnInit } from '../../../../../core/decorators';

@Component({
    selector: 'filter-text',
    bindings: {
        filter: '=',
        model: '='
    },
    template: require('./filter-text.tpl.html')
})
export class FilterTextComponent implements OnInit, OnDestroy {
    constructor() {}

    ngOnInit(): void {}

    ngOnDestroy(): void {}
}
